import { render, staticRenderFns } from "./HandheldTerminal.vue?vue&type=template&id=bed63a60&scoped=true"
import script from "./HandheldTerminal.vue?vue&type=script&lang=js"
export * from "./HandheldTerminal.vue?vue&type=script&lang=js"
import style0 from "./HandheldTerminal.vue?vue&type=style&index=0&id=bed63a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed63a60",
  null
  
)

export default component.exports